
<style scoped>


</style>

<template>
<div class="redditPost">

    reddit

</div>
</template>


<script>

export default{
    data:function(){
        return {

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/LegacyNews/redditStylePost.vue